import { ensureRouteData } from '@/app/query-client'
import { indicesQueryOptions } from '@/features/market/api/queries'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * The `/market/indices` loader.
 *
 * MAIN: the four-index table, awaited — the chart card reads it for the
 * selected row's name and percent change, and the table below it IS this
 * data, so neither can draw without it. No search param picks the selected
 * row (that lives in `IndicesScreen`'s own `useState`), so unlike the other
 * five families this pass converts, there is nothing SECONDARY to start
 * alongside it: the chart's own session series (`useIndexSummary`) keys off
 * the selection, which only exists once the table has rendered a first row to
 * default to, so starting it here would be a guess at a key the screen is
 * about to pick for itself.
 *
 * Its own module, as `app.guard.ts` is, so a test can mount it under a root
 * of its own: typed inside `createFileRoute`, a loader is bound to this
 * route's parent in the generated tree.
 */
export async function loadIndices({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<void> {
  await ensureRouteData(queryClient, indicesQueryOptions())
}
